function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.25,
    height: 10.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 5.22
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.44,
    width: 25.25,
    height: 14.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 17.9
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.36,
    width: 25.25,
    height: 18.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 34.8
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.23,
    width: 25.25,
    height: 22.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 55.419999999999995
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.62,
    width: 25.25,
    height: 22.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.582
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 78.075
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.53,
    width: 25.25,
    height: 25.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 102.305
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.08,
    width: 25.25,
    height: 26.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 128.295
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.51,
    width: 25.25,
    height: 28.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 155.86499999999998
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.22,
    width: 25.25,
    height: 28.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8055555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 184.6
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 198.98,
    width: 25.25,
    height: 29.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 213.54
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 228.1,
    width: 25.25,
    height: 32.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 244.4
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 260.7,
    width: 25.25,
    height: 32.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 277
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 293.31,
    width: 25.25,
    height: 34.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.607142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 310.785
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 328.26,
    width: 25.25,
    height: 39.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 347.825
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.39,
    width: 25.25,
    height: 44.01,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.15625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 389.395
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 411.4,
    width: 25.25,
    height: 44.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 433.715
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.03,
    width: 25.25,
    height: 44.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8055555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 478.49499999999995
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 500.96,
    width: 25.25,
    height: 45.29,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 523.605
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 546.26,
    width: 25.25,
    height: 47.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 570.185
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 594.1,
    width: 25.25,
    height: 52.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.15625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 620.4250000000001
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 646.76,
    width: 25.25,
    height: 53.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.625,
    y: 673.38
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 0,
    width: 32.6,
    height: 42.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.963636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.55,
    y: 21.175
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.85,
    y: 0,
    width: 32.9,
    height: 42.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.3,
    y: 21.175
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.75,
    y: 0,
    width: 33.01,
    height: 42.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.255,
    y: 21.175
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.76,
    y: 0,
    width: 33.48,
    height: 42.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.782857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.5,
    y: 21.175
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.24,
    y: 0,
    width: 34.12,
    height: 42.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.3,
    y: 21.175
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.36,
    y: 0,
    width: 34.8,
    height: 42.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.76000000000002,
    y: 21.175
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.16,
    y: 0,
    width: 35.64,
    height: 42.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.564
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.98,
    y: 21.175
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.79,
    y: 0,
    width: 37.23,
    height: 42.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.204999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.40500000000003,
    y: 21.175
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.03,
    y: 0,
    width: 37.38,
    height: 42.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.71999999999997,
    y: 21.175
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.41,
    y: 0,
    width: 38.46,
    height: 42.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.64000000000004,
    y: 21.175
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.87,
    y: 0,
    width: 41.01,
    height: 42.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.375,
    y: 21.175
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.88,
    y: 0,
    width: 43.34,
    height: 42.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.55,
    y: 21.175
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.22,
    y: 0,
    width: 43.36,
    height: 42.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.90000000000003,
    y: 21.175
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.59,
    y: 0,
    width: 47.04,
    height: 42.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.11,
    y: 21.175
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.63,
    y: 0,
    width: 48.19,
    height: 42.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 573.725,
    y: 21.175
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.82,
    y: 0,
    width: 50.49,
    height: 42.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.065,
    y: 21.175
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.31,
    y: 0,
    width: 51.69,
    height: 42.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.5875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.155,
    y: 21.175
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 42.35,
    width: 48.61,
    height: 45.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.168000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 65.27000000000001
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 88.18,
    width: 48.61,
    height: 46.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 111.53500000000001
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 134.9,
    width: 48.61,
    height: 47.39,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 158.595
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 182.28,
    width: 48.61,
    height: 48.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 206.44
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 230.61,
    width: 48.61,
    height: 48.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 254.85000000000002
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 279.09,
    width: 48.61,
    height: 49.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.101666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 303.59999999999997
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 328.11,
    width: 48.61,
    height: 49.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.050833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 352.745
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 377.38,
    width: 48.61,
    height: 49.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.07625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 402.09
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 426.8,
    width: 48.61,
    height: 49.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.101666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 451.71000000000004
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 476.61,
    width: 48.61,
    height: 52.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.401111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 502.92
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 529.24,
    width: 48.61,
    height: 55.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.07625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 557.035
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 584.83,
    width: 48.61,
    height: 56.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 613.0300000000001
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 641.22,
    width: 48.61,
    height: 58.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.944285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.555,
    y: 670.61
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 42.35,
    width: 49.43,
    height: 58.52,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.575,
    y: 71.61
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.29,
    y: 42.35,
    width: 49.68,
    height: 58.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.13,
    y: 71.61
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.98,
    y: 42.35,
    width: 52.37,
    height: 58.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.818888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.165,
    y: 71.61
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.35,
    y: 42.35,
    width: 53.01,
    height: 58.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.62625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.855,
    y: 71.61
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.36,
    y: 42.35,
    width: 53.53,
    height: 58.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.647142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.125,
    y: 71.61
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.89,
    y: 42.35,
    width: 55.35,
    height: 58.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9071428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.565,
    y: 71.61
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.24,
    y: 42.35,
    width: 60.18,
    height: 58.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.360000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.33,
    y: 71.61
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.41,
    y: 42.35,
    width: 60.81,
    height: 58.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.81500000000005,
    y: 71.61
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.22,
    y: 42.35,
    width: 62.48,
    height: 58.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.46,
    y: 71.61
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.7,
    y: 42.35,
    width: 63.65,
    height: 58.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.360000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.5250000000001,
    y: 71.61
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.35,
    y: 42.35,
    width: 65.65,
    height: 58.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.1750000000001,
    y: 71.61
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 100.86,
    width: 65.23,
    height: 60.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 131.005
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 161.15,
    width: 65.23,
    height: 62.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.872857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 192.205
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 223.26,
    width: 65.23,
    height: 62.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.431666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 254.555
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 285.85,
    width: 65.23,
    height: 63.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.044285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 317.505
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 349.17,
    width: 65.23,
    height: 64.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 381.21000000000004
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 413.24,
    width: 65.23,
    height: 67.4,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 446.94
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 480.65,
    width: 65.23,
    height: 68.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 514.795
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 548.94,
    width: 65.23,
    height: 74.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.247777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 586.1600000000001
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.86,
    y: 623.37,
    width: 65.23,
    height: 76.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.31857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.475,
    y: 661.685
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 100.86,
    width: 66.83,
    height: 76.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.138333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.505,
    y: 138.915
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.92,
    y: 100.86,
    width: 67.18,
    height: 76.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.51,
    y: 138.915
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.1,
    y: 100.86,
    width: 67.81,
    height: 76.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.562000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.005,
    y: 138.915
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.91,
    y: 100.86,
    width: 69.24,
    height: 76.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.847999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.53000000000003,
    y: 138.915
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.15,
    y: 100.86,
    width: 70.75,
    height: 76.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.791666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.525,
    y: 138.915
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 480.89,
    y: 100.86,
    width: 71.76,
    height: 76.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.77,
    y: 138.915
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.65,
    y: 100.86,
    width: 72.4,
    height: 76.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.044444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.85,
    y: 138.915
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.05,
    y: 100.86,
    width: 74.95,
    height: 76.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.525,
    y: 138.915
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 176.98,
    width: 82.36,
    height: 78.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.768888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.27,
    y: 216.44
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 255.9,
    width: 82.36,
    height: 84.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.27,
    y: 297.96500000000003
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 340.03,
    width: 82.36,
    height: 87.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.27,
    y: 383.66999999999996
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 427.31,
    width: 82.36,
    height: 88.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.27,
    y: 471.335
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 515.37,
    width: 82.36,
    height: 90.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.472
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.27,
    y: 560.48
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 605.58,
    width: 82.36,
    height: 94.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.765714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.27,
    y: 652.7900000000001
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.44,
    y: 176.98,
    width: 92.44,
    height: 85.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.72125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.65999999999997,
    y: 219.86499999999998
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.88,
    y: 176.98,
    width: 92.57,
    height: 85.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.16499999999996,
    y: 219.86499999999998
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.46,
    y: 176.98,
    width: 96.81,
    height: 85.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.865,
    y: 219.86499999999998
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.27,
    y: 176.98,
    width: 96.93,
    height: 85.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.72125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.735,
    y: 219.86499999999998
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.2,
    y: 176.98,
    width: 99.8,
    height: 85.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.252857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.1,
    y: 219.86499999999998
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.44,
    y: 262.74,
    width: 98.07,
    height: 89.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.16875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.475,
    y: 307.415
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.44,
    y: 352.1,
    width: 98.07,
    height: 101.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.475,
    y: 402.90000000000003
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.44,
    y: 453.69,
    width: 98.07,
    height: 113.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.915454545454544
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.475,
    y: 510.62
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.44,
    y: 567.55,
    width: 98.07,
    height: 132.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.806999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.475,
    y: 633.775
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.51,
    y: 262.74,
    width: 110.6,
    height: 128.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.81,
    y: 327.12
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.11,
    y: 262.74,
    width: 111.76,
    height: 128.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.99,
    y: 327.12
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.87,
    y: 262.74,
    width: 158.13,
    height: 128.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.39428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.935,
    y: 327.12
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.51,
    y: 391.51,
    width: 234.12,
    height: 119.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.57,
    y: 451.28
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.51,
    y: 511.05,
    width: 234.12,
    height: 188.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.177272727272726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.57,
    y: 605.525
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.63,
    y: 391.51,
    width: 146.37,
    height: 308.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.815,
    y: 545.755
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.0226a0b0330f4c236ccf3f4708a39786.svg";
export { ForwardRef as ReactComponent };